import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/filecoin-logo.svg';
import _imports_1 from '@/assets/images/icons/link.svg';
const _hoisted_1 = {
  class: "adjust"
};
const _hoisted_2 = {
  class: "row mb-2"
};
const _hoisted_3 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_4 = {
  class: "row"
};
const _hoisted_5 = {
  class: "col-12 mb-1 mt-2"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mt-4"
}, null, -1);
const _hoisted_7 = {
  key: 0,
  class: "row mb-2 mt-3"
};
const _hoisted_8 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_9 = {
  key: 1,
  class: "row"
};
const _hoisted_10 = {
  class: "col-12 mb-2 mt-2"
};
const _hoisted_11 = {
  key: 2,
  class: "row mb-2 mt-3"
};
const _hoisted_12 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_13 = {
  key: 3,
  class: "row mb-2 mt-3"
};
const _hoisted_14 = {
  key: 0,
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_15 = {
  key: 1,
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_16 = {
  class: "row"
};
const _hoisted_17 = {
  class: "col-12 mb-3 mt-2"
};
const _hoisted_18 = {
  key: 0,
  class: "row mt-4"
};
const _hoisted_19 = {
  class: "col-7 text-left fw-medium fsi-14 d-flex align-items-center"
};
const _hoisted_20 = {
  class: "mr-1"
};
const _hoisted_21 = {
  style: {
    "display": "inline-block",
    "transform": "translateY(2px)"
  }
};
const _hoisted_22 = {
  class: "col-5 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_23 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_24 = {
  key: 1,
  class: "row mt-4"
};
const _hoisted_25 = {
  class: "col-6 text-left fw-medium fsi-14 d-flex align-items-center"
};
const _hoisted_26 = {
  class: "mr-1"
};
const _hoisted_27 = {
  style: {
    "display": "inline-block",
    "transform": "translateY(2px)"
  }
};
const _hoisted_28 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_29 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_30 = {
  class: "row mt-3"
};
const _hoisted_31 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_32 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_33 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_34 = {
  key: 5,
  class: "row mt-4"
};
const _hoisted_35 = {
  class: "col-12"
};
const _hoisted_36 = {
  class: "d-flex align-items-center mb-1",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_37 = {
  class: "mr-2"
};
const _hoisted_38 = {
  class: "form-group mb-2"
};
const _hoisted_39 = {
  class: "position-relative"
};
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "left": "0",
    "z-index": "100",
    "width": "4rem"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1.8rem"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "29px",
    "height": "29px"
  },
  alt: ""
})])], -1);
const _hoisted_41 = {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "right": "0",
    "width": "6rem"
  }
};
const _hoisted_42 = ["disabled"];
const _hoisted_43 = {
  key: 6,
  class: "row mt-4"
};
const _hoisted_44 = {
  class: "col-12"
};
const _hoisted_45 = {
  class: "d-flex align-items-center mb-1",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_46 = {
  class: "mr-2"
};
const _hoisted_47 = {
  class: "form-group mb-2"
};
const _hoisted_48 = {
  class: "position-relative"
};
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "left": "0",
    "z-index": "100",
    "width": "4rem"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1.8rem"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "29px",
    "height": "29px"
  },
  alt: ""
})])], -1);
const _hoisted_50 = {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "right": "0",
    "width": "6rem"
  }
};
const _hoisted_51 = ["disabled"];
const _hoisted_52 = {
  key: 7,
  class: "row mb-5"
};
const _hoisted_53 = {
  class: "col-12 mt-3 mb-2"
};
const _hoisted_54 = {
  class: "mt-1 col-12 mt-3"
};
const _hoisted_55 = {
  class: "pl-2 pr-2"
};
const _hoisted_56 = {
  key: 8,
  class: "row mt-4"
};
const _hoisted_57 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_58 = {
  key: 0,
  class: "row mt-4"
};
const _hoisted_59 = {
  class: "col-7 text-left fw-medium fsi-14 d-flex align-items-center"
};
const _hoisted_60 = {
  class: "mr-1"
};
const _hoisted_61 = {
  style: {
    "display": "inline-block",
    "transform": "translateY(2px)"
  }
};
const _hoisted_62 = {
  class: "col-5 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_63 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_64 = {
  key: 1,
  class: "row mt-4"
};
const _hoisted_65 = {
  class: "col-6 text-left fw-medium fsi-14 d-flex align-items-center"
};
const _hoisted_66 = {
  class: "mr-1"
};
const _hoisted_67 = {
  style: {
    "display": "inline-block",
    "transform": "translateY(2px)"
  }
};
const _hoisted_68 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_69 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_70 = {
  key: 10,
  class: "row mt-3"
};
const _hoisted_71 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_72 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_73 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_74 = {
  key: 11,
  class: "row mb-4"
};
const _hoisted_75 = {
  class: "col-12 mt-3 mb-3"
};
const _hoisted_76 = {
  class: "col-12 mt-3"
};
const _hoisted_77 = {
  class: "pl-2 pr-2"
};
const _hoisted_78 = {
  key: 12,
  class: "row mt-5"
};
const _hoisted_79 = {
  class: "col-12"
};
const _hoisted_80 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_81 = {
  class: "mr-2"
};
const _hoisted_82 = {
  class: "fw-bold"
};
const _hoisted_83 = {
  key: 1,
  class: "d-flex align-items-center justify-content-between",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_84 = {
  class: "mr-2"
};
const _hoisted_85 = {
  class: "fw-bold"
};
const _hoisted_86 = {
  style: {
    "color": "#bbbbbb"
  },
  class: "mr-2 fw-medium"
};
const _hoisted_87 = {
  key: 13,
  class: "row mt-3"
};
const _hoisted_88 = {
  class: "col-5 text-left fw-medium fsi-14"
};
const _hoisted_89 = {
  class: "col-7 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_90 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_91 = {
  key: 14,
  class: "row mt-3"
};
const _hoisted_92 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_93 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_94 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_95 = {
  class: "row mt-3"
};
const _hoisted_96 = {
  class: "col-7 text-left fw-medium fsi-14"
};
const _hoisted_97 = {
  style: {
    "display": "inline-block",
    "transform": "translateY(2px)"
  }
};
const _hoisted_98 = {
  key: 0
};
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "5px",
    "height": "5px",
    "background-color": "#3ac72f",
    "border-radius": "5px",
    "transform": "translateY(-2px)"
  },
  class: "mr-1"
}, null, -1);
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "5px",
    "height": "5px",
    "background-color": "#3ac72f",
    "border-radius": "5px",
    "transform": "translateY(-2px)"
  },
  class: "mr-1"
}, null, -1);
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "5px",
    "height": "5px",
    "background-color": "#3ac72f",
    "border-radius": "5px",
    "transform": "translateY(-2px)"
  },
  class: "mr-1"
}, null, -1);
const _hoisted_102 = {
  key: 1
};
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "display": "inline-block",
    "width": "5px",
    "height": "5px",
    "background-color": "#3ac72f",
    "border-radius": "5px",
    "transform": "translateY(-2px)"
  },
  class: "mr-1"
}, null, -1);
const _hoisted_104 = {
  class: "col-5 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_105 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_106 = {
  key: 15,
  class: "row mt-3"
};
const _hoisted_107 = {
  class: "col-8 text-left fw-medium fsi-14"
};
const _hoisted_108 = {
  class: "col-4 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_109 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_110 = {
  key: 16,
  class: "row mt-3"
};
const _hoisted_111 = {
  class: "col-8 text-left fw-medium fsi-14"
};
const _hoisted_112 = {
  class: "col-4 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_113 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_114 = {
  key: 17,
  class: "row mt-3"
};
const _hoisted_115 = {
  class: "col-8 text-left fw-medium fsi-14"
};
const _hoisted_116 = {
  class: "col-4 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_117 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mt-4"
}, null, -1);
const _hoisted_119 = {
  class: "row mb-3 mt-2"
};
const _hoisted_120 = {
  class: "col-12 text-left fw-extra-bold fsi-16 mt-2",
  style: {
    "cursor": "pointer"
  }
};
const _hoisted_121 = {
  class: "row mt-3"
};
const _hoisted_122 = {
  class: "col-8 text-left fw-medium fsi-14"
};
const _hoisted_123 = {
  class: "col-4 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_124 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_125 = {
  class: "row mt-3"
};
const _hoisted_126 = {
  class: "col-8 text-left fw-medium fsi-14"
};
const _hoisted_127 = {
  class: "col-4 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_128 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_129 = {
  class: "row mt-3"
};
const _hoisted_130 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_131 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_132 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_133 = {
  class: "row mt-3"
};
const _hoisted_134 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_135 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_136 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_137 = {
  class: "row mt-3"
};
const _hoisted_138 = {
  class: "col-7 text-left fw-medium fsi-14"
};
const _hoisted_139 = {
  class: "col-5 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_140 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_141 = {
  class: "mt-4"
};
const _hoisted_142 = {
  key: 1,
  class: "d-flex align-items-center"
};
const _hoisted_143 = {
  key: 4,
  class: "ml-2 cursor-pointer icon-hover"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RadioBtn = _resolveComponent("RadioBtn");
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_IndicatorValue = _resolveComponent("IndicatorValue");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_IndicatorRay = _resolveComponent("IndicatorRay");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('farm.console.Choosethewayyoulike')), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_RadioBtn, {
    disabled: $data.loading,
    "tab-arr": $data.tabOptions1,
    modelValue: $data.radio1,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.radio1 = $event)
  }, null, 8, ["disabled", "tab-arr", "modelValue"])])]), _hoisted_6, $data.radio1 === 'By Amount' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('farm.console.WhichActionWouldYouLikeToChoose')), 1)])) : _createCommentVNode("", true), $data.radio1 === 'By Amount' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_RadioBtn, {
    disabled: $data.loading,
    "tab-arr": $data.tabOptions2,
    modelValue: $data.radio2,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.radio2 = $event)
  }, null, 8, ["disabled", "tab-arr", "modelValue"])])])) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.isBorrowed ? _ctx.$t('farm.console.Whatinterestratedoyoupreferforborrowing') : _ctx.$t('farm.console.Whatyourpreferredrepaymentinterestrate')), 1)])) : _createCommentVNode("", true), $data.radio1 === 'By Amount' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [$data.radio2 === 'Borrowing' ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('farm.console.Whatinterestratedoyoupreferforborrowing')), 1)) : _createCommentVNode("", true), $data.radio2 === 'Repayment' ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('farm.console.Whatyourpreferredrepaymentinterestrate')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_RadioBtn, {
    disabled: $data.loading || _ctx.currentLoading,
    "tab-arr": $data.tabOptions3,
    modelValue: $data.radio3,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.radio3 = $event)
  }, null, 8, ["disabled", "tab-arr", "modelValue"])])]), $data.radio1 === 'By Amount' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 4
  }, [$data.radio3 === 'Variable' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('farm.console.OutstandingVariableDebt')), 1), _createElementVNode("span", _hoisted_21, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.OutstandingVariableDebtTip')), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.variableDebtValue,
      "new-value": _ctx.variableDebtValue
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio3 === 'Stable' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('farm.console.OutstandingStableDebt')), 1), _createElementVNode("span", _hoisted_27, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.OutstandingStableDebtTip')), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.stableDebtValue,
      "new-value": _ctx.stableDebtValue
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('farm.console.MaximumBorrowingLimit')), 1), _createElementVNode("div", _hoisted_32, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.availableBorrowingAmount,
      "new-value": _ctx.availableBorrowingAmount
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])], 64)) : _createCommentVNode("", true), $data.radio2 === 'Borrowing' && $data.radio1 === 'By Amount' ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('farm.console.Youareborrowing')), 1)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-info btn-sm btn-max",
    style: {
      "padding": "4px 15px"
    },
    onClick: _cache[3] || (_cache[3] = (...args) => $options.borrowMax && $options.borrowMax(...args))
  }, _toDisplayString(_ctx.$t("max")), 1)]), _withDirectives(_createElementVNode("input", {
    class: "form-control shadow-none stake-input",
    onInput: _cache[4] || (_cache[4] = (...args) => $options.adjustBorrowingValueChange && $options.adjustBorrowingValueChange(...args)),
    disabled: $data.loading,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.adjustBorrowingValue = $event),
    type: "number",
    placeholder: "0.00",
    autocomplete: "off",
    id: "fname2",
    required: ""
  }, null, 40, _hoisted_42), [[_vModelText, $data.adjustBorrowingValue]])])])])])) : _createCommentVNode("", true), $data.radio2 === 'Repayment' && $data.radio1 === 'By Amount' ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('farm.console.Youarerepaying')), 1)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_hoisted_49, _createElementVNode("div", _hoisted_50, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-info btn-sm btn-max",
    style: {
      "padding": "4px 15px"
    },
    onClick: _cache[6] || (_cache[6] = (...args) => $options.maxRepay && $options.maxRepay(...args))
  }, _toDisplayString(_ctx.$t("max")), 1)]), _withDirectives(_createElementVNode("input", {
    class: "form-control shadow-none stake-input",
    onInput: _cache[7] || (_cache[7] = (...args) => $options.adjustRepayingValueChange && $options.adjustRepayingValueChange(...args)),
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.adjustRepayingValue = $event),
    disabled: $data.loading,
    type: "number",
    placeholder: "0.00",
    autocomplete: "off",
    id: "fname3",
    required: ""
  }, null, 40, _hoisted_51), [[_vModelText, $data.adjustRepayingValue]])])])])])) : _createCommentVNode("", true), $data.radio1 === 'By Amount' ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('farm.console.CurrentLeverage')), 1), _createElementVNode("div", _hoisted_54, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_55, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    }), _createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      style: _normalizeStyle([{
        "background-color": "#fafafa",
        "border-radius": "5px"
      }, {
        paddingBottom: _ctx.guaranteeLeverage > 10000n ? '12px' : '0px'
      }]),
      class: "pl-2 pr-2"
    }, [_createVNode(_component_el_slider, {
      disabled: "",
      "format-tooltip": $options.sliderFormatTip,
      placement: "top",
      max: _ctx.marksMax,
      modelValue: $data.sliderValue,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.sliderValue = $event),
      marks: _ctx.marks
    }, null, 8, ["format-tooltip", "max", "modelValue", "marks"]), _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: "Top Left prompts info",
      placement: "top"
    }, {
      default: _withCtx(() => [_ctx.guaranteeLeverage > 10000n ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "guaranteeLeverageSlider",
        style: _normalizeStyle({
          width: _ctx.guaranteeLeverageSliderWidth
        })
      }, null, 4)) : _createCommentVNode("", true)]),
      _: 1
    })], 4)]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('farm.console.Pleasemakechangestotheleverage')), 1)])) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 9
  }, [$data.radio3 === 'Variable' ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('farm.console.OutstandingVariableDebt')), 1), _createElementVNode("span", _hoisted_61, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.OutstandingVariableDebtTip')), 1)]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_62, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.variableDebtValue,
      "new-value": _ctx.variableDebtValue
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio3 === 'Stable' ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("span", _hoisted_66, [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.OutstandingStableDebt')) + " ", 1), _createElementVNode("span", _hoisted_67, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.OutstandingStableDebtTip')), 1)]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_68, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_69, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.stableDebtValue,
      "new-value": _ctx.stableDebtValue
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('farm.console.MaximumBorrowingLimit')), 1), _createElementVNode("div", _hoisted_72, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_73, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.availableBorrowingAmount,
      "new-value": _ctx.availableBorrowingAmount
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t('farm.console.TargetLeverage')), 1), _createElementVNode("div", _hoisted_76, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_77, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    }), _createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      ref: "main-slider",
      style: _normalizeStyle([{
        "background-color": "#fafafa",
        "border-radius": "5px"
      }, {
        paddingBottom: _ctx.guaranteeLeverage > 10000n ? '12px' : '0px'
      }]),
      class: _normalizeClass(["pl-2 pr-2", _ctx.sliderChangeClass])
    }, [_createVNode(_component_el_slider, {
      disabled: $data.loading,
      "format-tooltip": $options.sliderFormatTip,
      placement: "top",
      onInput: $options.changeSliderValue,
      max: _ctx.marksMax,
      step: 0.1,
      modelValue: $data.sliderValue,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.sliderValue = $event),
      marks: _ctx.marks
    }, null, 8, ["disabled", "format-tooltip", "onInput", "max", "step", "modelValue", "marks"]), _createVNode(_component_el_tooltip, {
      class: "box-item",
      effect: "dark",
      content: _ctx.$t('farm.console.This is the debt of the collateral node'),
      placement: "top"
    }, {
      default: _withCtx(() => [_ctx.guaranteeLeverage > 10000n ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "guaranteeLeverageSlider",
        style: _normalizeStyle({
          width: _ctx.guaranteeLeverageSliderWidth
        })
      }, null, 4)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["content"])], 6)]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio1 === 'By Leverage' ? (_openBlock(), _createElementBlock("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_ctx.youAreBorrowing >= 0n ? (_openBlock(), _createElementBlock("div", _hoisted_80, [_createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t('farm.console.Youareborrowing')), 1), _createElementVNode("span", _hoisted_82, _toDisplayString($options.externalFormatFilPrice(_ctx.youAreBorrowing)), 1)])) : _createCommentVNode("", true), _ctx.youAreBorrowing < 0n ? (_openBlock(), _createElementBlock("div", _hoisted_83, [_createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$t('farm.console.Youarerepaying')), 1), _createElementVNode("span", _hoisted_85, [_createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.isYouAreRePayingAll ? '(ALL) ' : ''), 1), _createTextVNode(" " + _toDisplayString($options.externalFormatFilPrice(_ctx.youAreBorrowing).replace('-', '')), 1)])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), $data.radio3 === 'Variable' ? (_openBlock(), _createElementBlock("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.$t('farm.console.CurrentVariableDebt')), 1), _createElementVNode("div", _hoisted_89, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_90, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.variableDebtValue,
      "new-value": _ctx.afterVariableDebtValue
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio3 === 'Stable' ? (_openBlock(), _createElementBlock("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.$t('farm.console.CurrentStableDebt')), 1), _createElementVNode("div", _hoisted_93, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_94, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.stableDebtValue,
      "new-value": _ctx.afterStableDebtValue
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_createTextVNode(_toDisplayString($data.radio3 === 'Stable' ? _ctx.$t('farm.console.SingleRemainingBorrowingCapacity') : _ctx.$t('farm.console.RemainingBorrowingCapacity')) + " ", 1), _createElementVNode("span", _hoisted_97, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("div", null, [_ctx.liquidityReserveRatio > 0n ? (_openBlock(), _createElementBlock("div", _hoisted_98, [_hoisted_99, _createElementVNode("span", null, _toDisplayString(_ctx.$t('subpool.The total amount borrowed by the platform cannot be greater than the liquidity pool').replace("$$$", `${(parseFloat((10000n - _ctx.liquidityReserveRatio).toString()) / 100).toFixed(1)}%`)), 1)])) : _createCommentVNode("", true), _createElementVNode("div", null, [_hoisted_100, _createElementVNode("span", null, _toDisplayString(_ctx.$t('farm.console.The loan amount cannot exceed the maximum leverage')), 1)]), _createElementVNode("div", null, [_hoisted_101, _createElementVNode("span", null, _toDisplayString(_ctx.$t('farm.console.The loan amount cannot exceed the available liquid funds')), 1)]), $data.radio3 === 'Stable' ? (_openBlock(), _createElementBlock("div", _hoisted_102, [_hoisted_103, _createElementVNode("span", null, _toDisplayString(_ctx.$t('farm.console.The maximum borrowing amount for stable debt cannot exceed of the available liquid funds').replace("$$$", (parseFloat(_ctx.maxStableRateBorrowSizePercent.toString()) / 100).toFixed(1).toString())), 1)])) : _createCommentVNode("", true)])]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_104, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_105, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [$data.radio3 === 'Variable' ? (_openBlock(), _createBlock(_component_IndicatorValue, {
      key: 0,
      "old-value": _ctx.leftAvailableBorrowingAmount,
      "new-value": _ctx.afterLeftAvailableBorrowingAmount
    }, null, 8, ["old-value", "new-value"])) : _createCommentVNode("", true), $data.radio3 === 'Stable' ? (_openBlock(), _createBlock(_component_IndicatorValue, {
      key: 1,
      "old-value": _ctx.stableBorrowingAmount,
      "new-value": _ctx.afterStableBorrowingAmount
    }, null, 8, ["old-value", "new-value"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])])]), $data.radio3 === 'Variable' ? (_openBlock(), _createElementBlock("div", _hoisted_106, [_createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.$t('farm.console.VariableInterestRate')), 1), _createElementVNode("div", _hoisted_108, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_109, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorRay, {
      suffix: "%",
      units: 2,
      "old-value": _ctx.variableBorrowSimpleRate,
      "new-value": _ctx.afterVariableRate
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio3 === 'Stable' ? (_openBlock(), _createElementBlock("div", _hoisted_110, [_createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.$t('farm.console.CurrentStableInterestRate')), 1), _createElementVNode("div", _hoisted_112, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_113, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorRay, {
      suffix: "%",
      units: 2,
      "old-value": _ctx.stableBorrowSimpleRate,
      "new-value": _ctx.stableBorrowSimpleRate
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), $data.radio3 === 'Stable' ? (_openBlock(), _createElementBlock("div", _hoisted_114, [_createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.$t('farm.console.StableInterestRate')), 1), _createElementVNode("div", _hoisted_116, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_117, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorRay, {
      suffix: "%",
      units: 2,
      "old-value": _ctx.userStableSimpleRate,
      "new-value": _ctx.afterStableRate
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])) : _createCommentVNode("", true), _hoisted_118, _createElementVNode("div", _hoisted_119, [_createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.$t('farm.console.Isthiswhatyouexpected')), 1)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_121, [_createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.$t('farm.console.CurrentFarmAPR')), 1), _createElementVNode("div", _hoisted_123, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_124, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorRay, {
      suffix: "%",
      units: 2,
      "old-value": _ctx.currentFarmAPR,
      "new-value": _ctx.afterCurrentFarmAPR
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_125, [_createElementVNode("div", _hoisted_126, _toDisplayString(_ctx.$t('farm.console.CurrentBorrowingInterestAPR')), 1), _createElementVNode("div", _hoisted_127, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_128, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", null, " - " + _toDisplayString($options.formatPrice($options.formatUnits(_ctx.afterCurrentBorrowingInterestAPR, 2), 2)) + " % ", 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_129, [_createElementVNode("div", _hoisted_130, _toDisplayString(_ctx.$t('farm.console.TotalAPR')), 1), _createElementVNode("div", _hoisted_131, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_132, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorRay, {
      suffix: "%",
      units: 2,
      "old-value": _ctx.totalAPR,
      "new-value": _ctx.afterTotalAPR
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, _toDisplayString(_ctx.$t('farm.console.DailyAPR')), 1), _createElementVNode("div", _hoisted_135, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_136, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorRay, {
      suffix: "%",
      toFixed: 4,
      units: 6,
      "old-value": _ctx.dailyAPR,
      "new-value": _ctx.afterDailyAPR
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_137, [_createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.$t('farm.console.EstimatedDailyEarnings')), 1), _createElementVNode("div", _hoisted_139, [_createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_140, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_IndicatorValue, {
      "old-value": _ctx.estimatedDailyEarnings,
      "new-value": _ctx.afterEstimatedDailyEarnings
    }, null, 8, ["old-value", "new-value"])]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_141, [!_ctx.isConnected ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "btn btn-primary w-100 border-radius-20",
    type: "submit",
    onClick: _cache[11] || (_cache[11] = (...args) => $options.connectWallet && $options.connectWallet(...args))
  }, _toDisplayString(_ctx.$t('farm.console.ConnectOperatorWallet')) + " " + _toDisplayString(_ctx.isConnecting ? ' (connecting...)' : ''), 1)) : _createCommentVNode("", true), _ctx.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_142, [$data.radio1 === 'By Leverage' && _ctx.isBorrowed ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.borrow,
    disabled: _ctx.youAreBorrowing === 0n || !_ctx.stableRateEnabled && $data.radio3 === 'Stable',
    loading: $data.loading || _ctx.assetsLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(!_ctx.stableRateEnabled && $data.radio3 === 'Stable' ? _ctx.$t('farm.console.DISABLED') : $data.btnText !== '' ? $data.btnText : _ctx.$t('farm.console.BORROW')), 1)]),
    _: 1
  }, 8, ["onClick", "disabled", "loading"])) : _createCommentVNode("", true), _ctx.isConnected && $data.radio1 === 'By Leverage' && !_ctx.isBorrowed ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    class: "btn btn-info w-100 i-button",
    onClick: $options.repay,
    disabled: _ctx.youAreBorrowing === 0n,
    loading: $data.loading || _ctx.assetsLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnText !== '' ? $data.btnText : _ctx.$t('farm.console.REPAY')), 1)]),
    _: 1
  }, 8, ["onClick", "disabled", "loading"])) : _createCommentVNode("", true), _ctx.isConnected && $data.radio1 === 'By Amount' && $data.radio2 === 'Borrowing' ? (_openBlock(), _createBlock(_component_el_button, {
    key: 2,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.borrow,
    disabled: $data.adjustBorrowingValue === '' || $data.adjustBorrowingValue === 0 || !_ctx.stableRateEnabled && $data.radio3 === 'Stable',
    loading: $data.loading || _ctx.assetsLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(!_ctx.stableRateEnabled && $data.radio3 === 'Stable' ? _ctx.$t('farm.console.DISABLED') : $data.btnText !== '' ? $data.btnText : _ctx.$t('farm.console.BORROW')), 1)]),
    _: 1
  }, 8, ["onClick", "disabled", "loading"])) : _createCommentVNode("", true), _ctx.isConnected && $data.radio1 === 'By Amount' && $data.radio2 === 'Repayment' ? (_openBlock(), _createBlock(_component_el_button, {
    key: 3,
    class: "btn btn-info w-100 i-button",
    onClick: $options.repay,
    disabled: $data.adjustRepayingValue === '' || $data.adjustRepayingValue === 0,
    loading: $data.loading || _ctx.assetsLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnText !== '' ? $data.btnText : _ctx.$t('farm.console.REPAY')), 1)]),
    _: 1
  }, 8, ["onClick", "disabled", "loading"])) : _createCommentVNode("", true), $data.hash !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_143, [_createElementVNode("img", {
    onClick: _cache[12] || (_cache[12] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale)),
    style: {
      "width": "32px"
    },
    src: _imports_1,
    alt: ""
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]);
}